import { BaseLlmNodeMenuController, LlmConversationNode } from '@adaptiva/ai/common';
import { MenuItem } from '@adaptiva/core/menus';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class LlmArtifactMenuController extends BaseLlmNodeMenuController {

	public override readonly createForkMenuName: string = 'Fork';

	public override readonly goToChatMenuName: string = 'Go to Chat';

	public override readonly showHistoryMenuName: string = 'History';

	public override generate(_node: LlmConversationNode): Observable<MenuItem<LlmConversationNode>[]> {
		return of([
			this.getCreateForkMenuItem(_node),
			this.getOpenInChatMenuItem(_node),
			this.getOpenInHistoryMenuItem(_node),
		]);
	}

	public override getCreateForkMenuItem(_node: LlmConversationNode): MenuItem<LlmConversationNode> {
		const _item: MenuItem = super.getCreateForkMenuItem(_node);

		_item.icon.next({ icon: 'faCodeFork', color: 'foreground' });

		return _item;
	}

	public override getOpenInChatMenuItem(_node: LlmConversationNode): MenuItem<LlmConversationNode> {
		const _item: MenuItem = super.getOpenInChatMenuItem(_node);

		_item.icon.next({ icon: 'faCommentAlt', color: 'foreground' });

		return _item;
	}

	public override getOpenInHistoryMenuItem(_node: LlmConversationNode): MenuItem<LlmConversationNode> {
		const _item: MenuItem = super.getOpenInHistoryMenuItem(_node);

		_item.icon.next({ icon: 'faClockRotateLeft', color: 'foreground' });

		return _item;
	}

}
